<template>
    <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div class="row justify-content-center">
			<div class="col-lg-8">
				<div class="fee-detail">
					<h4>GHS Portfolios Fees:</h4>
					<p>
						The fees you pay for our services includes charges for administrative as well as management services and is a percentage based upon the aggregate market values of all managed assets in the portfolio. 
						An annual fee of 1.75% accrues daily and is calculated by dividing the annual rate (1.75%) by 365 days and multiplying by the aggregate market value of the portfolio. 
						The value of the portfolio is then adjusted accordingly.
					</p>
				</div>
				<div class="fee-detail">
					<h4>USD Portfolios Fees:</h4>
					<p>
						The fees you pay for our services includes charges for administrative as well as management services and is a percentage based upon the aggregate market values of all managed assets in the portfolio. 
						An annual fee of 0.75% accrues daily and is calculated by dividing the annual rate (0.75%) by 365 days and multiplying by the aggregate market value of the portfolio. 
						The value of the portfolio is then adjusted accordingly.
					</p>
					<p>
						Transaction fees including fees related to international funds transfer, brokerage and commission are additional and determined by our service providers. 
						We may combine your order with orders of other clients to allow us to negotiate better prices or lower commission rates and other transaction charges than we could get for your order alone. 
						We will allocate securities so purchased or sold, as well as the expenses incurred in the transaction, in the manner that we consider to be equitable and consistent with our fiduciary obligations to you and our other clients.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.fee-detail {
		margin-bottom: 30px;
	}
</style>

<script>
	export default {
		mounted() {}
	};
</script>
